export const youtubeConstants = {
	GET_YOUTUBE_STREAMS_STATS_REQUEST: 'GET_YOUTUBE_STREAMS_STATS_REQUEST',
	GET_YOUTUBE_STREAMS_STATS_SUCCESS: 'GET_YOUTUBE_STREAMS_STATS_SUCCESS',
	GET_YOUTUBE_STREAMS_STATS_FAILURE: 'GET_YOUTUBE_STREAMS_STATS_FAILURE',
	GET_YOUTUBE_DEMOGRAPHICS_STATS_REQUEST: 'GET_YOUTUBE_DEMOGRAPHICS_STATS_REQUEST',
	GET_YOUTUBE_DEMOGRAPHICS_STATS_SUCCESS: 'GET_YOUTUBE_DEMOGRAPHICS_STATS_SUCCESS',
	GET_YOUTUBE_DEMOGRAPHICS_STATS_FAILURE: 'GET_YOUTUBE_DEMOGRAPHICS_STATS_FAILURE',
	GET_YOUTUBE_TERRITORY_STATS_REQUEST: 'GET_YOUTUBE_TERRITORY_STATS_REQUEST',
	GET_YOUTUBE_TERRITORY_STATS_SUCCESS: 'GET_YOUTUBE_TERRITORY_STATS_SUCCESS',
	GET_YOUTUBE_TERRITORY_STATS_FAILURE: 'GET_YOUTUBE_TERRITORY_STATS_FAILURE',
	GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_REQUEST: 'GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_REQUEST',
	GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_SUCCESS: 'GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_SUCCESS',
	GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_FAILURE: 'GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_FAILURE',    
	GET_YOUTUBE_SOURCE_STATS_REQUEST: 'GET_YOUTUBE_SOURCE_STATS_REQUEST',
	GET_YOUTUBE_SOURCE_STATS_SUCCESS: 'GET_YOUTUBE_SOURCE_STATS_SUCCESS',
	GET_YOUTUBE_SOURCE_STATS_FAILURE: 'GET_YOUTUBE_SOURCE_STATS_FAILURE',
	GET_YOUTUBE_SOURCE_DISCOVERY_STATS_REQUEST: 'GET_YOUTUBE_SOURCE_DISCOVERY_STATS_REQUEST',
	GET_YOUTUBE_SOURCE_DISCOVERY_STATS_SUCCESS: 'GET_YOUTUBE_SOURCE_DISCOVERY_STATS_SUCCESS',
	GET_YOUTUBE_SOURCE_DISCOVERY_STATS_FAILURE: 'GET_YOUTUBE_SOURCE_DISCOVERY_STATS_FAILURE',    
	GET_YOUTUBE_PLAYLIST_STATS_REQUEST: 'GET_YOUTUBE_PLAYLIST_STATS_REQUEST',
	GET_YOUTUBE_PLAYLIST_STATS_SUCCESS: 'GET_YOUTUBE_PLAYLIST_STATS_SUCCESS',
	GET_YOUTUBE_PLAYLIST_STATS_FAILURE: 'GET_YOUTUBE_PLAYLIST_STATS_FAILURE',
	GET_YOUTUBE_TOP_PLAYLIST_STATS_REQUEST: 'GET_YOUTUBE_TOP_PLAYLIST_STATS_REQUEST',
	GET_YOUTUBE_TOP_PLAYLIST_STATS_SUCCESS: 'GET_YOUTUBE_TOP_PLAYLIST_STATS_SUCCESS',
	GET_YOUTUBE_TOP_PLAYLIST_STATS_FAILURE: 'GET_YOUTUBE_TOP_PLAYLIST_STATS_FAILURE',    
	GET_YOUTUBE_REPEAT_LISTENERS_REQUEST: 'GET_YOUTUBE_REPEAT_LISTENERS_REQUEST',
	GET_YOUTUBE_REPEAT_LISTENERS_SUCCESS: 'GET_YOUTUBE_REPEAT_LISTENERS_SUCCESS',
	GET_YOUTUBE_REPEAT_LISTENERS_FAILURE: 'GET_YOUTUBE_REPEAT_LISTENERS_FAILURE',
	GET_YOUTUBE_TOP_TRACKS_TIMESERIES_REQUEST: 'GET_YOUTUBE_TOP_TRACKS_TIMESERIES_REQUEST',
	GET_YOUTUBE_TOP_TRACKS_TIMESERIES_SUCCESS: 'GET_YOUTUBE_TOP_TRACKS_TIMESERIES_SUCCESS',
	GET_YOUTUBE_TOP_TRACKS_TIMESERIES_FAILURE: 'GET_YOUTUBE_TOP_TRACKS_TIMESERIES_FAILURE',
	GET_YOUTUBE_REPEAT_LISTENERS_RATIO_REQUEST: 'GET_YOUTUBE_REPEAT_LISTENERS_RATIO_REQUEST',
	GET_YOUTUBE_REPEAT_LISTENERS_RATIO_SUCCESS: 'GET_YOUTUBE_REPEAT_LISTENERS_RATIO_SUCCESS',
	GET_YOUTUBE_REPEAT_LISTENERS_RATIO_FAILURE: 'GET_YOUTUBE_REPEAT_LISTENERS_RATIO_FAILURE',
	GET_YOUTUBE_DEVICE_STATS_REQUEST: 'GET_YOUTUBE_DEVICE_STATS_REQUEST',
	GET_YOUTUBE_DEVICE_STATS_SUCCESS: 'GET_YOUTUBE_DEVICE_STATS_SUCCESS',
	GET_YOUTUBE_DEVICE_STATS_FAILURE: 'GET_YOUTUBE_DEVICE_STATS_FAILURE',       
	GET_YOUTUBE_SOURCE_TIMESERIES_REQUEST: 'GET_YOUTUBE_SOURCE_TIMESERIES_REQUEST',
	GET_YOUTUBE_SOURCE_TIMESERIES_SUCCESS: 'GET_YOUTUBE_SOURCE_TIMESERIES_SUCCESS',
	GET_YOUTUBE_SOURCE_TIMESERIES_FAILURE: 'GET_YOUTUBE_SOURCE_TIMESERIES_FAILURE',
	GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_REQUEST: 'GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_REQUEST',
	GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_SUCCESS: 'GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_SUCCESS',
	GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_FAILURE: 'GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_FAILURE',    
	GET_YOUTUBE_TOP_TRACKS_REQUEST: 'GET_YOUTUBE_TOP_TRACKS_REQUEST',
	GET_YOUTUBE_TOP_TRACKS_SUCCESS: 'GET_YOUTUBE_TOP_TRACKS_SUCCESS',
	GET_YOUTUBE_TOP_TRACKS_FAILURE: 'GET_YOUTUBE_TOP_TRACKS_FAILURE',
	GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_REQUEST: 'GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_REQUEST',
	GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_SUCCESS: 'GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_SUCCESS',
	GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_FAILURE: 'GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_FAILURE',    
	
}